<template>
  <v-container id="evidence-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row v-if="municipioTarefaP.municipioTarefa.municipioTarefaId">
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-evidence
              :edit="false"
              :municipioTarefaP="municipioTarefaP"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              @onSave="$emit('reloadEvidences')"
              v-if="isFullAdmin"
            >
              <template v-slot:title>
                Cadastramento Evidência
              </template>
            </app-modal-insert-evidence>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="evidences"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-evidence
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @on-save="$emit('reloadEvidences')"
                >
                  <template v-slot:title>
                    Edição de Evidência
                  </template>
                </app-modal-insert-evidence>
              </v-col>

              <v-col cols="1" class="col-min-width-bigger">
                <app-modal-delete-evidence
                  :payload="item"
                  @onDeleteEvidence="$emit('reloadEvidences')"
                >
                  <template v-slot:title>
                    Deletar Evidência
                  </template>
                </app-modal-delete-evidence>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEvidence from "./ModalInsert";
import AppModalDeleteEvidence from "./ModalDelete";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppEvidenceList",
  props: {
    filter: { type: Object, required: true },
    evidences: { type: Array, required: true },
    municipioTarefaP: { type: Object, required: true }
  },
  components: {
    AppModalInsertEvidence,
    AppModalDeleteEvidence
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome"
        },
        {
          text: "Descricao",
          value: "descricao"
        },
        {
          text: "Tarefa",
          value: "municipioTarefa.nome"
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false
        }
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia"
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia"
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia"
        },
        {
          text: "Evidências",
          disabled: true,
          href: "termo-referencia"
        }
      ]
    };
  },
  mounted() {
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isNA",
      "isFullAdmin"
    ])
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio"
    ]),
    reloadEvidences() {
      this.$emit("onDeleteEvidence");
    }
  }
};
</script>

<style lang="scss">
@import "./../style.scss";
</style>
